import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './assets/logo.svg'


const _hoisted_1 = {
  id: "app",
  class: "container"
}
const _hoisted_2 = { class: "row justify-content-center align-items-center py-3 py-md-5" }
const _hoisted_3 = { class: "content col-xl-8 col-lg-10 col-12 p-3 px-md-5 py-md-4 rounded" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Azuriom logo",
    class: "logo mb-4"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AzuriomInstaller = _resolveComponent("AzuriomInstaller")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_AzuriomInstaller)
      ])
    ])
  ]))
}